<template>
    <div id="breadcrumb_area">
        <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }" class="home_breadcrumb">
                ホーム
            </el-breadcrumb-item>
            <el-breadcrumb-item
                v-for="(item, index) in levelList"
                :key="item.path"
            >
                <span
                    v-if="
                        index == levelList.length - 1 && pageTitle !== undefined
                    "
                    class="no-redirect"
                    >{{ pageTitle }}</span
                >
                <span
                    v-else-if="index == levelList.length - 1"
                    class="no-redirect"
                    >{{ item.meta.title }}</span
                >
                <a v-else @click.prevent="handleLink(item)">{{
                    item.meta.title
                }}</a>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { defineComponent, ref, watch, toRef } from "vue";

export default defineComponent({
    name: "PageBreadcrumbs",
    props: {
        label: {
            type: String,
        },
    },
    setup(props) {
        const router = useRouter();
        const route = useRoute();

        const levelList = ref([]); // パンくずリストを蓄積

        watch(
            () => route.path,
            () => {
                getBreadcrumb();
            }
        );

        // labelが入力された場合、パンくずリスト（末尾）にはラベルを使用する
        const pageTitle = toRef(props, "label");

        function getBreadcrumb() {
            if (route.name != "Top") {
                // only show routes with meta.title
                let matched = route.matched.filter(
                    (item) => item.meta && item.meta.title
                );

                levelList.value = matched.filter(
                    (item) =>
                        item.meta &&
                        item.meta.title &&
                        item.meta.breadcrumb !== false
                );
            }
        }

        let path = null; // useRoute()からのpath格納用
        function pathCompile(path) {
            return path;
        }

        function handleLink(route) {
            path = route.path;
            const redirect = route.redirect;
            if (redirect) {
                router.push(redirect);
                return;
            }
            router.push(pathCompile(path));
        }

        getBreadcrumb();

        return {
            levelList,
            handleLink,
            path,
            pageTitle,
        };
    },
});
</script>

<style scoped>
#breadcrumb_area {
    width: 100vw;
    margin: 0 calc(50% - 50vw);
    margin-bottom: 10px;
    background-color: #edf1f1;
}
.breadcrumb {
    padding-bottom: 0.5em;
    line-height: 1.5;
    padding: 5px;
    width: 980px;
    margin-left: auto;
    margin-right: auto;
}
.home_breadcrumb {
    padding-left: 23px;
    background: url("../../../public/images//icon_breadcrumb.png") no-repeat 0
        1px;
}
/* .breadcrumb li:first-child {
    padding-left: 23px;
    background: url(../images/icon_breadcrumb.png) no-repeat 0 5px;
} */
</style>
